export default function ({ $axios, redirect, error, route, app, store }) {
	// 401 se záměrně propouští jako "úspěšný" status - přihlašovací stránky si chybovou
	// zprávu čtou přímo z response. Odhlášení a přesměrování řeší onResponse/onError níže.
	$axios.defaults.validateStatus = (status) => {
		return [ 200, 401 ].indexOf(status) !== -1;
	};

	// Chybová zpráva z API. Response nemusí existovat vůbec (spadlé připojení, CORS, timeout)
	// a nemusí být ani JSON (HTML stránka od proxy), proto se k message nesmí sahat přímo.
	const errorMessage = (response) => {
		if (!response || !response.data || typeof response.data.message !== 'string') {
			return '';
		}

		return response.data.message;
	};

	// Chyby z přihlašování si zobrazuje samotná stránka, nesmí se na ně přesměrovávat
	const isLoginMessage = (message) => {
		return message.includes('LOGIN ERROR:') || message === 'User is not allowed to access from current IP address.';
	};

	const logoutAndRedirect = (response) => {
		if (!isLoginMessage(errorMessage(response))) {
			redirect(`/?backlink=${ app.localePath(route.path) }&backlinkQuery=${ JSON.stringify(route.query) }`);
		}

		store.commit('userLogin/RESET_USER_LOGIN_DATA');
	};

	$axios.onResponse(async (response) => {
		if (response.status === 401) {
			logoutAndRedirect(response);
		}

		return response;
	});

	$axios.onError(err => {
		const code = parseInt(err.response && err.response.status);
		// const isCustomerReport = route.path === '/customer-report' && route.query.token;
		const isCustomerReport = app.localePath('/customer-report') && route.query.token;

		if (isCustomerReport) {
			if (errorMessage(err.response) === 'Claim was not found.') {
				error({ statusCode: code, message: 'Claim nenalezen.' });
			}

			return;
		}

		// Neplatné přihlášení znamená jedině 401 - všechny chyby autentizace ho vrací
		// (AuthenticationRequestDecorator, UserService).
		if (code === 401) {
			logoutAndRedirect(err.response);
		}

		// 400 NENÍ chyba přihlášení: vrací ho validace request body, přihlašovací
		// endpoint (LoginController) a DiagnosticsController, který jím přebaluje
		// i 404. Odhlašovat a přesměrovávat na něj proto nelze - uživatel by přišel
		// o rozpracovaný formulář. Chybu zobrazí komponenta, která request poslala.
		if (code === 400) {
			/* eslint-disable no-console */
			console.error(`API 400: ${ errorMessage(err.response) }`, err);
			/* eslint-enable no-console */
		}

		if (code === 503 || code === 500) {
			error({ statusCode: code, message: 'Chyba serveru.' });
		}
	});
}
